// Field-masking for Staff front KYC saves (Phase 4 of the staff-roles work).
// A masked payload contains ONLY the permitted subtrees plus addressing/scope fields,
// so protected compliance data can neither be smuggled in nor stale-overwritten.
// Pure function — the sole mutation choke points (KycFormPage's two setDoc sites)
// call this; Firestore rules enforce the same boundary server-side.
import { PERMITTED_KYC_SUBTREES } from "../auth/permissions";

const PASSTHROUGH_FIELDS = [
  "orgId",
  "accessScope",
  "ownerUid",
  "teamId",
  "clientId",
  "updatedAt",
];

export function maskKycPayload(payload, { masked, preserveCreatedAt = false } = {}) {
  if (!masked) return payload;
  const out = {};
  for (const key of [...PERMITTED_KYC_SUBTREES, ...PASSTHROUGH_FIELDS]) {
    if (payload?.[key] !== undefined) out[key] = payload[key];
  }
  // Never mint createdAt from a masked save; carry it only when it already existed.
  if (preserveCreatedAt && payload?.createdAt !== undefined) out.createdAt = payload.createdAt;
  return out;
}
